export default "__VITE_ASSET__CSPSgxCs__"